__turbopack_context__.v({
  "content": "RedirectLoadingOverlay-module__lD66IG__content",
  "indicator": "RedirectLoadingOverlay-module__lD66IG__indicator",
  "overlay": "RedirectLoadingOverlay-module__lD66IG__overlay",
});
